import { get, post, put, deleteReq } from '../../../../infra/rest';
import { CustomerChatMeta, InternalNote, InternalNotesListResponse, CreateInternalNoteRequest } from '../typings';

export const getCustomerDetails = async ({
  customerId,
  integrationId,
  integrationWabaNumber,
  source,
}: {
  customerId: string;
  integrationId?: string;
  integrationWabaNumber?: string;
  source?: string;
}): Promise<CustomerChatMeta> => {
  const params = new URLSearchParams();
  if (integrationId) params.set('integrationId', integrationId);
  if (integrationWabaNumber) params.set('integrationWabaNumber', integrationWabaNumber);
  if (source) params.set('source', source);
  const query = params.toString() ? `?${params.toString()}` : '';

  return get<CustomerChatMeta>(`/v5/customer/details/${customerId}${query}`, {}, true);
};

export const getInternalNotes = async ({
  customerId,
  chatId,
  includeCountOnly,
  lastNoteId,
  lastNoteDate,
}: {
  customerId: string;
  chatId: string;
  includeCountOnly: boolean;
  lastNoteId?: string;
  lastNoteDate?: string;
}): Promise<InternalNotesListResponse> => {
  return get<InternalNotesListResponse>(
    `/v2/customer-notes?includeCountOnly=${includeCountOnly}&customerId=${customerId}&chatId=${chatId}&lastNoteId=${
      lastNoteId || ''
    }&lastNoteDate=${lastNoteDate || ''}`,
    {},
    true
  );
};

export const createInternalNote = async (internalNote: CreateInternalNoteRequest): Promise<InternalNote> => {
  return post<InternalNote>(
    `/v2/customer-notes`,
    {
      body: JSON.stringify(internalNote),
    },
    true
  );
};

export const editInternalNote = async (internalNote: InternalNote): Promise<InternalNote> => {
  return put<InternalNote>(
    `/v2/customer-notes/:internalNoteId`.replace(':internalNoteId', internalNote.id),
    {
      body: JSON.stringify(internalNote),
    },
    true
  );
};

export const deleteInternalNote = async (internalNoteId: string, chatId: string): Promise<void> => {
  return deleteReq<void>(`/v2/customer-notes/${internalNoteId}/${chatId}`, undefined, true);
};
